<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">Reconcile Trx.Credit - Bank & Cash (Sub Modul vs GL)
        <div class="card-header-actions">
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="6">
          <b-input-group >
              <b-input-group-prepend><span class="pt-2 mr-1">Cash/bank Account</span></b-input-group-prepend>
              <b-form-input readonly v-model="model.namabank" @keyup.13.native="lkuBankaccountShow=true" ></b-form-input>
              <b-input-group-append>
                  <b-btn text="Button" @click="lkuBankaccountShow=true">
                      <i class="fa fa-search"></i>
                  </b-btn>
              </b-input-group-append>
              <b-input-group-append><span class="pt-2 ml-2 mr-1">GL Account#</span></b-input-group-append>
              <b-input-group-append>
                  <span class="input-group-text" style="min-width:150px;">{{model.kodeacc}}</span>
              </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="6" xl="5">
          <b-input-group >
            <b-input-group-prepend><span class="pt-2 mr-1">Trx. Date</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl1" type="date" ></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="model.tgl2" type="date" ></b-form-input>
            <b-input-group-append ><b-button class="ml-2 btn btn-success mr-2" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
          <template v-slot:header v-if="(filterShow=='Hide')">          
            <b-row >
                <b-col lg="3">
                  <b-input-group size="sm" class="mt-1">
                    <b-input-group-prepend><span class="pt-1 mr-1" >FILTER</span></b-input-group-prepend>
                    <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                        ></b-form-input>
                    <b-input-group-append>
                    <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                    </b-input-group-append>
                    </b-input-group>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>

                </b-col> 
                <b-col lg="9">
                  <b-form-group
                    label="FILTER ON :"
                    label-cols-sm="1"
                    description="Leave all unchecked to filter on all data"
                    class="mb-0">
                    <b-form-checkbox-group v-model="filterOn" class="mt-1">
                      <b-form-checkbox value="rekonsil">Rekon Status</b-form-checkbox>
                      <b-form-checkbox value="uraian1">Description Sub Modul</b-form-checkbox>
                      <b-form-checkbox value="uraian2">Description GL</b-form-checkbox>
                      <b-form-checkbox value="nilai1">Value Sub Modul </b-form-checkbox>
                      <b-form-checkbox value="nilai2">Value GL</b-form-checkbox>
                    </b-form-checkbox-group>
                  </b-form-group>                
                </b-col>                 
            </b-row>
        </template>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
            <template v-slot:thead-top="data">
              <b-tr>
                <b-th colspan="6" class="text-center">SUB MODUL</b-th>
                <b-th variant="warning" class="text-center">REKON</b-th>
                <b-th variant="success" colspan="4" class="text-center">GL-ACCOUNTING</b-th>
              </b-tr>
            </template>

              <template v-slot:cell(tanggal1)="data">
                  <span v-if="(data.item.tanggal1)">{{ data.item.tanggal1 | moment("DD-MMM-YYYY") }}</span>
              </template>
              <template v-slot:cell(tanggal2)="data">
                  <span v-if="(data.item.tanggal2)">{{ data.item.tanggal2 | moment("DD-MMM-YYYY") }}</span>
              </template>
                <template v-slot:cell(nilaiori)="data">
                      {{ data.item.matauang }} &nbsp; {{ data.item.nilaiori | numFormat }}
                </template>
                <template v-slot:cell(nilai1)="data">
                      {{ data.item.nilai1 | numFormat }}
                </template>
                <template v-slot:cell(nilai2)="data">
                      {{ data.item.nilai2 | numFormat }}
                </template>
                <template v-slot:cell(valas_in)="data">
                      {{ data.item.valas_in | numFormat }}
                </template>
                <template v-slot:cell(valas_out)="data">
                      {{ data.item.valas_out | numFormat }}
                </template>
                <template v-slot:cell(sakhirOri)="data">
                      {{ data.item.sakhirOri | numFormat }}
                </template>
            </b-table>
            <b-row class="mt-2">
                <b-col lg="7">
                    <b-row >
                      <b-col cols="8">
                        <div class="ml-1">
                          Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                          to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                          of {{tblLcy.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="tblLcy.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                          </select>
                        </div>
                        <b-pagination  class="ml-1" 
                          align="left"
                          :total-rows="tblLcy.total"
                          :per-page="tblLcy.limit"
                          v-model="tblLcy.page"
                        ></b-pagination>
                      </b-col>
                      <b-col cols="4">            
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b>  Filter
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                </b-col>
                <b-col lg="5">
                  <b-form-row>
                    <b-col md="4">
                      <b-form-group label="Total Sub Modul" >
                          <my-number class="form-control text-right" v-model="subtotal.totalModul" :precision="2" disabled></my-number>
                      </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Total GL" >
                            <my-number class="form-control text-right" v-model="subtotal.totalGl" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Selisih" >
                            <my-number class="form-control text-right" v-model="subtotal.selisih" :precision="2" disabled></my-number>
                        </b-form-group>                  
                    </b-col>
                  </b-form-row>
                </b-col>

            </b-row>
      </b-card>

      <!-- <div class="report-wraper">
          <table style="width: 100%;">
            <thead>
              <tr>
                  <th colspan="6" style="text-align:center;border-right: 2px solid black;">SUB MODUL</th>
                  <th colspan="4" style="text-align:center;">GL-ACCOUNTING</th>
              </tr>
              <tr>
                  <th width="120px">Trx.Number</th>
                  <th width="90px"> Trx.date</th>
                  <th><div style="width: 200px; overflow: hidden; display: inline-block; white-space: nowrap;">Trx. Description</div></th>
                  <th width="150px">bank/Cash Account</th>
                  <th style="text-align:right" width="120px">Trx. Value (FCY)</th>
                  <th style="text-align:right; border-right: 2px solid black;" width="110px">Trx. Value ({{uanguser}})</th>
                  <th width="120px">GL.Number</th>
                  <th width="90px"> GL.Date</th>
                  <th><div style="width: 200px; overflow: hidden; display: inline-block; white-space: nowrap;">GL Description</div></th>
                  <th style="text-align:right;" width="120px">GL.Value ({{uanguser}})</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="row in rptLines" :key="row.tablekey"  :class="{ selisih: row.rekonsil === 0}">
                  <td width="120px">{{row.nomor1}}</td>
                  <td width="90px"> <span v-if="(row.tanggal1)">{{row.tanggal1 | moment("DD MMM YYYY")}}</span></td>
                  <td><div style="width: 200px; overflow: hidden; display: inline-block; white-space: nowrap;">{{row.uraian1}}</div></td>
                  <td width="150px">{{row.bankinfo}}</td>
                  <td v-if="(row.nilaiori)" style="text-align:right;" width="120px"><span style="float:left;">{{row.matauang}}</span> &nbsp; {{row.nilaiori | numFormat('0,0.00')}}</td>
                  <td v-else width="110px"></td>
                  <td v-if="(row.nilai1)" style="text-align:right;border-right: 2px solid black;" width="110px">{{row.nilai1 | numFormat('0,0.00')}}</td>
                  <td v-else style="text-align:right;border-right: 2px solid black;" width="110px"></td>
                  <td width="120px">{{row.nomor2}}</td>
                  <td width="90px"> <span v-if="(row.tanggal2)">{{row.tanggal2 | moment("DD MMM YYYY")}}</span></td>
                  <td><div style="width: 310px; overflow: hidden; display: inline-block; white-space: nowrap;">{{row.uraian2}}</div></td>
                  <td v-if="(row.nilai2)" style="text-align:right;" width="110px">{{row.nilai2 | numFormat('0,0.00')}}</td>
                  <td v-else width="110px"></td>
              </tr>
            </tbody>
          </table>
      </div>
      <hr>
      <b-row >
        <b-col cols="3">
          <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </b-col>
        <b-col cols="3">Total Sub Modul : {{subtotal.totalModul | numFormat('0,0.00')}}</b-col>
        <b-col cols="3">Total GL : {{subtotal.totalGl | numFormat('0,0.00')}}</b-col>
        <b-col cols="3">Selisih  : {{(subtotal.totalModul-subtotal.totalGl) | numFormat('0,0.00')}}</b-col>
      </b-row> -->

    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
        <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData" aktif=1></lku-bankaccount>
    </b-modal>        

  </div>
</template>

<style lang="scss" scoped>
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;

        table {
            font-size: smaller;
            th {
                border-bottom: 1px solid #D1D1D1;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border-bottom: 1px solid #f5f5f5;
                padding: 0 10px;
                height: 25px;
            }

            tr.selisih {
              background: yellow;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
            
            td.total {
                border-top: 2px solid #000 !important;
                background: #e6e6e6 !important;
            }
            
            td.grdtotal {
                border-top: 2px solid #000!important;
                border-bottom: 2px double #000 !important;
                background: #e6e6e6 !important;
            }
        }
    }
 
</style>

<script>
import moment from 'moment';
import myNumber from "../../components/my-number";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import tranbank from "../../apis/tranbank";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl1: { required },
        tgl2: { required },
    },
  }, 
  data() {
    return {
        lkuBankaccountData:{},
      lkuBankaccountShow: false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model: {kodebank:'',tgl1:'',tgl2:''},
      uanguser: this.$store.state.user.matauang,
      bankCashAcc: [],
      rptLines : [],
      subtotal : {},
      filterShow:'Show',
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "nomor1",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "tanggal1",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian1",
            label: "Description",
          },
          {
            key: "bankinfo",
            label: "Bank/Cash Account",
            sortable: true
          },
          {
            key: "nilaiori",
            label: "Trx. Value (FCY)",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "nilai1",
            label: "Trx. Value (LCY)",
            thStyle: "width:140px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "rekonsil",
            label: "STATUS",
            thStyle: "width:30px",
            thClass: "text-center text-warning",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor2",
            label: "GL Number",
            thClass: "text-success",
            sortable: true
          },
          {
            key: "tanggal2",
            label: "GL. Date",
            thStyle: "width:90px",
            thClass: "text-center text-success",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "uraian2",
            thClass: "text-success",
            label: "Description",
          },
          {
            key: "nilai2",
            label: "GL Value",
            thStyle: "width:140px",
            thClass: "text-right text-success",
            tdClass: "text-right"
          },
        ]
      },
      filter: null,
      filterOn: [],   
    };
  },
  components: {Loading, myNumber, lkuBankaccount},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },  
  created: async function(){
      const accList = await tranbank.bankaccount();
      this.bankCashAcc = accList.reduce((newArr,item) =>{
            newArr.push(item);
            return newArr;
        },[{ value: '', text: '--- ALL ---'}]);
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');

  },  
  methods: {
    onSelectLkuBankaccount(lkuData) {
        this.lkuBankaccountData=lkuData;
        this.lkuBankaccountShow=false;
        this.model.kodebank=lkuData.selected.kode;
        this.model.matauang=lkuData.selected.matauang;
        this.model.namabank=lkuData.selected.namabank;
        this.model.namaacc=lkuData.selected.namabank || '';
        this.model.nomorrek=lkuData.selected.nomorrek;
        this.model.kodeacc=lkuData.selected.kodeacc;
        this.lkuBankaccountShow=false;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
        const result = await tranbank.rekonkr(this.model);
        this.rptLines =  result[0];
        this.subtotal = result[1][0];     
        this.subtotal.selisih=this.subtotal.totalModul-this.subtotal.totalGl;
        this.tblLcy.total = this.rptLines.length;        
        this.isLoading=false;      
       }
    },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            const response = await tranbank.rekonkrexport(this.model);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
      }
    },    
    close(){
      router.push("/treasury/home");
    }
  }
};
</script>
